import React from "react"
import Title from "../Title"
import styles from "../../css/about.module.css"
// import img from "../../images/defaultBcg.jpeg"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import AniLink from "gatsby-plugin-transition-link/AniLink"
// import hustle from "../../images/milestone-winners.jpg";

const getAbout = graphql`
  query aboutImage {
    aboutImage: file(relativePath: { eq: "aboutimg.JPG" }) {
      childImageSharp {
        fluid(maxWidth: 600) {
          ...GatsbyImageSharpFluid_tracedSVG
        }
      }
    }
  }
`

// const getAbout2 = graphql`
//   query hustleImage {
//     hustleImage: file(relativePath: { eq: "hustle.jpg" }) {
//       childImageSharp {
//         fluid(maxWidth: 600) {
//           ...GatsbyImageSharpFluid_tracedSVG
//         }
//       }
//     }
//   }
// `
{/* <img className="img-fluid"  src={require('./hustle.jpg')} /> 
<img  className="img-fluid "src={hustle} alt="palmtree" />
*/}

const About = () => {
  const { aboutImage } = useStaticQuery(getAbout)
 
 

  return (
    <section className={styles.about}>
      <Title title="Heart of an Lion" subtitle="Blood of an Engineer" />
      <div className={styles.aboutCenter}>
        <article className={styles.aboutImg}>
          <div className={styles.imgContainer}>
            {/* <img src={img} alt="about company" /> */}
            <Img
              fluid={aboutImage.childImageSharp.fluid}
              alt="awesome landscape"
            />
          </div>
        </article> 
        <article className={styles.aboutInfo}>
          <h4>With a passion for analyzing and visualizing data.</h4>
        
          <div className={styles.aboutDiv}>
          <p>
            </p> 
            
            <p></p>
            
            {/* <img src={img} alt="about company" /> */}
          
          
          <p>
          Interested in working with passionate people on activism, tech, data, and logistical challenges.
          </p>

          </div>
          <AniLink fade to="/contact" className="btn-primary">
        Lets Connect
      </AniLink>
          
        </article>
      </div>
    </section>
  )
}

export default About


















// import React from "react"
// import Title from "../Title"
// import styles from "../../css/about.module.css"
// import img from "../../images/aboutheadshot2.png"
// import tashara from "../../images/tasharaheadshot.jpg"
// import { useStaticQuery, graphql } from "gatsby"



// const getAbout = graphql`
//   query aboutImage {
//     aboutImage: file(relativePath: { eq: "defaultBcg.jpeg" }) {
//       childImageSharp {
//         fluid(maxWidth: 600) {
//           ...GatsbyImageSharpFluid_tracedSVG
//         }
//       }
//     }
//   }
// `
// const About = () => {
//   return (
//     const { aboutImage } = useStaticQuery(getAbout)
//     <section className={styles.about}>
  
//       <Title title="about" subtitle="US" />
    
//       <div className={styles.aboutCenter}>
//         <article className={styles.aboutImg}>
//           <div className={styles.imgContainer}>
//             <img src={img} alt="about Greg"/>
//         </div>
//         </article>
//         <article className={styles.aboutImg}>

//         <div className={styles.imgContainer}>
//             <img src={tashara} alt="about Tashara"/>
//         </div>
//         </article>
//         <article>
//         <h4>explore the difference</h4>
//           <p>
//             Quality matters. Give your fan base, online community, and supporters a notable first and lasting impression.
//           </p>
//           <p>
//             Using the power of digital to bring you to the next level.
//           </p>
//           <button type="button" className="btn-primary">
//             read more
//           </button>
//         </article>
//       </div>
      
//     </section>
//   )
// }

// const Wrapper = styled.div`
// text-align:center;
// text-transform:capitalize;
// width:80vw;
// margin: 0 auto 10rem auto;
// `
// export default About
